import { atomWithStorage } from 'jotai/utils';
import { CACHED_COUNTRIES_KEY } from '@/const/storage-key';
import type { CountryListRes } from '@/types/api/user-auth/country-list';

// 定义国家数据类型
export type CountryData = NonNullable<CountryListRes['countries']>[0];

// 使用 atomWithStorage 进行持久化存储
export const countriesAtom = atomWithStorage<CountryData[] | null>(CACHED_COUNTRIES_KEY, null);

// 获取国家的工具函数
export const findCountryByCode = (countries: CountryData[] | null, code: string): CountryData | undefined => {
  if (!countries) return undefined;
  return countries.find(country => country.code === code);
};

// 过滤国家的工具函数
export const filterCountries = (
  countries: CountryData[] | null,
  searchValue: string
): CountryData[] => {
  if (!countries) return [];
  if (!searchValue.trim()) return countries;

  const searchLower = searchValue.toLowerCase();
  return countries.filter(country =>
    country.cn.toLowerCase().includes(searchLower) ||
    country.en.toLowerCase().includes(searchLower) ||
    country.mobileCode.includes(searchValue)
  );
};
